import PageHero from "../../components/PageHero/PageHero";
import {images} from "../../constants"

import PortfolioShowcase from "../../components/PortfolioShow/PortfolioShowCase";
import { ExperienceSection, Footer, InfiniteMarquee } from "../../container";
import ContentImageSection from "../../components/ContentImageSection/ContentImageSection";
const Exterior = () => {
  return <>
    <PageHero title="Architectural Design Portfolio"  bgImage={images.backgroud_img}/>
    <ContentImageSection
  title="Precision Architectural Support, Tailored for You "
  description="
    Gomal Design Studio is your strategic partner in architectural outsourcing.
We combine technical mastery with creative insight to deliver more than drawings. We deliver clarity, confidence, and compelling results. From concept to construction-ready documents,we transform your ideas into stunning visualizations and meticulously coordinated Revit models, ensuring your project not only meets expectations but exceeds them.
  "
  highlightWords={["Archilance LLC", "Revit drafting"]}
  image={images.architectural_portfolio}
/>
    <div style={{ width: "80%", margin: "3rem auto" }}>
      <hr style={{ border: "none", height: "1px", backgroundColor: "#ddd" }} />
    </div>
    <PortfolioShowcase page="architecture" />
    <InfiniteMarquee/>
    <ExperienceSection/>
    <Footer/>
  </>;
};

export default Exterior;
